import type { IngredientStats } from '@/services/ingredient.service';

export interface IngredientKpis {
  totalIngredients: number;
  lowStock: number;
  outOfStock: number;
}

// Regression: GitHub issue #284 — "Ingredients page loads at most 500 rows with
// no indication — on tenants with more ingredients, rows silently vanish and the
// Low/Out-of-Stock KPIs undercount".
//
// The three KPI cards must reflect EVERY active ingredient, not the ≤500-row
// slice the table fetches. A critically-low ingredient at position 501+ was
// never counted. They now come from the tenant-wide `/ingredients/stats`
// aggregate. This maps that stats response into the KPI card values; before it
// loads (null) we show zeros rather than a slice-derived undercount.
export function deriveIngredientKpis(stats: IngredientStats | null): IngredientKpis {
  return {
    totalIngredients: stats?.total_ingredients ?? 0,
    lowStock: stats?.low_stock ?? 0,
    outOfStock: stats?.out_of_stock ?? 0,
  };
}
